<script>
import BaseWidgetForm from './BaseWidgetForm'

export default {
  extends: BaseWidgetForm,
  computed: {
    tabsFieldsSchema() {
      return [
        {
          label: 'Ogólne',
          fields: [...this.getCommonFields()]
        }
      ]
    }
  }
}
</script>
